import { render, staticRenderFns } from "./AppNavigationCategory.vue?vue&type=template&id=ddee8646&scoped=true&"
import script from "./AppNavigationCategory.vue?vue&type=script&lang=js&"
export * from "./AppNavigationCategory.vue?vue&type=script&lang=js&"
import style0 from "./AppNavigationCategory.vue?vue&type=style&index=0&id=ddee8646&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddee8646",
  null
  
)

export default component.exports